import React, { Component } from 'react';

export default class FOUROHFOUR extends Component {
  render() {
    return (
      <div id="oop">
        <h1>And I oop...</h1>
        <h2>
          Looks like you were trying to get to a place but we didn't have a
          place for that place, so now you are at this place, which is the place
          that you will be placed at when the place you were looking for are not
          found
        </h2>
        <h2>
          BUT look at that nice background....wow.... Thanks for sharing this
          moment with us
        </h2>
        <h2>Don't worry! just click our logo to go back to our main page!</h2>
      </div>
    );
  }
}
